import util from '../util';

let controller = 'SolicitacaoCCS';

export default {
    Listar: (dto, options) => {
        if (options && options.data) dto.data = options.data
        return util.Axios.GetAll(controller + '/listar', dto)
    },
    BucarCorrentista: function (DocumentoFederal) {
        return util.Axios.Get(`${controller}/${DocumentoFederal}/buscar-correntista`)
    },
    BucarDetalhes: function (Codigo) {
        return util.Axios.Get(`${controller}/${Codigo}/buscar-detalhes`)
    },
    BuscarContasVinculadasDetalheCCS0001: function (Codigo) {
        return util.Axios.GetAll(`${controller}/${Codigo}/buscar-contas-vinculadas-detalhe-ccs0001`)
    },
    BuscarContaCCS0003: function (CodigoConta) {
        return util.Axios.Get(`${controller}/${CodigoConta}/buscar-conta-ccs0003`)
    },
    BuscarCorrentistasVinculadosContaCCS0003: function (dto) {
        return util.Axios.GetAll(controller + '/correntistas-vinculados-contas-ccs0003', dto)
    }
}